import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import AddContractModal from './AddContractModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-contract-modal-container"></div>`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(AddContractModal)
    }).$mount('#gnzs-1c-amo__add-contract-modal-container');
}